import { useState, useEffect } from 'react'
import { UserPlanType } from './planSwitcher.model'
import { UsePlanSwitcherProps } from './planSwitcher.model'

export function usePlanSwitcher({ showOwnPlans, showAssignedPlans, initialValue }: UsePlanSwitcherProps) {
  let defaultValue: UserPlanType = 'own'
  if (showOwnPlans) defaultValue = 'own'
  if (!showOwnPlans && showAssignedPlans) defaultValue = 'assigned'
  if (showOwnPlans && showAssignedPlans && initialValue) defaultValue = initialValue

  const [value, setValue] = useState<UserPlanType>(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const canSwitch = showOwnPlans && showAssignedPlans

  return {
    value,
    setValue,
    canSwitch,
    showOwnPlans,
    showAssignedPlans,
  }
}
